// Test IDs for the EcoBike Camping Supplies Co. marketing site.
// Keys camelCase, values kebab-case `<feature>-<element>`.

export const HOME = {
  // Navigation
  navBrand: 'nav-brand',
  navHome: 'nav-home',
  navAbout: 'nav-about',
  navEbikes: 'nav-ebikes',
  navCamping: 'nav-camping',
  navAdaptive: 'nav-adaptive',
  navContact: 'nav-contact',
  navEnquireCta: 'nav-enquire-cta',
  navMobileToggle: 'nav-mobile-toggle',

  // Hero
  heroSection: 'hero-section',
  heroPrimaryCta: 'hero-primary-cta',
  heroSecondaryCta: 'hero-secondary-cta',

  // Sections
  aboutSection: 'about-section',
  ebikesSection: 'ebikes-section',
  campingSection: 'camping-section',
  adaptiveSection: 'adaptive-section',
  contactSection: 'contact-section',

  // Product cards (generic test ids per item)
  productCard: (slug) => `product-card-${slug}`,
  productEnquireBtn: (slug) => `product-enquire-${slug}`,

  // Enquiry form
  enquiryForm: 'enquiry-form',
  enquiryName: 'enquiry-name',
  enquiryEmail: 'enquiry-email',
  enquiryPhone: 'enquiry-phone',
  enquirySubject: 'enquiry-subject',
  enquiryInterest: 'enquiry-interest',
  enquiryMessage: 'enquiry-message',
  enquirySubmit: 'enquiry-submit',
  enquirySuccess: 'enquiry-success',
  enquiryError: 'enquiry-error',

  // Newsletter
  newsletterSection: 'newsletter-section',
  newsletterEmail: 'newsletter-email',
  newsletterSubmit: 'newsletter-submit',
  newsletterSuccess: 'newsletter-success',
  newsletterError: 'newsletter-error',

  // Field Notes
  fieldNotesSection: 'field-notes-section',
  fieldNotesCard: (slug) => `field-notes-card-${slug}`,
  fieldNotesReadAll: 'field-notes-read-all',
  fieldNotesPostPage: 'field-notes-post-page',
  fieldNotesIndexPage: 'field-notes-index-page',
  fieldNotesBackLink: 'field-notes-back-link',

  // Checkout
  productBuyBtn: (slug) => `product-buy-${slug}`,
  checkoutSuccessPage: 'checkout-success-page',
  checkoutCancelPage: 'checkout-cancel-page',
  checkoutStatus: 'checkout-status',
  checkoutAmount: 'checkout-amount',
  checkoutProductName: 'checkout-product-name',
  checkoutContinueShopping: 'checkout-continue-shopping',
  checkoutRetry: 'checkout-retry',

  // Footer
  footerYear: 'footer-year',
};
